import React from 'react'

const Footer = () => {
    return (
        <div className='Footer'>
            <p>&copy; Copyright - 2022 Lixuan Luo</p>
        </div>
    )
}

export default Footer
